import { Card, CardContent, CardHeader, CardTitle } from './ui/card'
import { Button } from './ui/button'
import ContactForm from './ContactForm'
import { 
  MapPin, 
  Phone, 
  Mail, 
  Clock,
  MessageSquare,
  Calendar,
  Globe
} from 'lucide-react'

const Contact = () => {
  const contactInfo = [
    {
      icon: MapPin,
      title: "Adres",
      details: [
        "Fatih Mahallesi, Osman Gazi Cd. No:1",
        "Kahramankazan/Ankara, Türkiye",
        
      ],
      color: "blue"
    },
    {
      icon: Phone,
      title: "Telefon",
      details: [
        "+90 312 811 10 06",
        "+90 551 865 01 50 "
      ],
      color: "green"
    },
    {
      icon: Mail,
      title: "E-posta",
      details: [
        "antrepo@capitaltrans.com.tr",
      ],
      color: "purple"
    },
    {
      icon: Clock,
      title: "Çalışma Saatleri",
      details: [
        "Pazartesi - Cuma: 09:00 - 18:00",
        "Cumartesi-Pazar: Kapalı",
      ],
      color: "orange"
    }
  ]

  const getColorClasses = (color) => {
    const colors = {
      blue: "bg-blue-100 text-blue-600",
      green: "bg-green-100 text-green-600",
      purple: "bg-purple-100 text-purple-600",
      orange: "bg-orange-100 text-orange-600"
    }
    return colors[color] || colors.blue
  }

  return (
    <section id="contact" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            İletişim
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Antrepo gümrük işlemleriniz için bizimle iletişime geçin. 
            Uzman ekibimiz size en uygun çözümü sunmak için hazır.
          </p>
        </div>


          {/* Contact Info & Quick Actions */}
          <div className="space-y-6">
            {/* Contact Information */}
            <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
  {contactInfo.map((info, index) => {
    const IconComponent = info.icon
    return (
      <Card
        key={index}
        className="p-6 text-center border border-gray-200 hover:shadow-lg hover:scale-[1.02] transition-all duration-200 bg-white"
      >
        <CardContent className="flex flex-col items-center">
          <div
            className={`w-12 h-12 rounded-full ${getColorClasses(
              info.color
            )} flex items-center justify-center mb-3`}
          >
            <IconComponent size={24} />
          </div>
          <h3 className="font-semibold text-gray-900 mb-2">{info.title}</h3>
          {info.details.map((detail, detailIndex) => (
            <p
              key={detailIndex}
              className="text-sm text-gray-600 leading-relaxed"
            >
              {detail}
            </p>
          ))}
        </CardContent>
      </Card>
    )
  })}
</div>


           
            
        {/* Google Maps Section */}
<div className="mt-12">
  <Card className="overflow-hidden">
    <CardContent className="p-0">
      <div className="relative w-full h-[450px]">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3045.7809821266396!2d32.68590437650031!3d40.236171666608044!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40826f9d8512b2bb%3A0x3bad4c29681e551e!2sCapital%20Antrepo!5e0!3m2!1str!2str!4v1760061818729!5m2!1str!2str"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Capital Antrepo Harita"
        ></iframe>
      </div>

      <div className="p-4 flex flex-wrap gap-3">
        <Button
          as="a"
          href="https://www.google.com/maps/dir/?api=1&destination=40.236171666608044,32.68590437650031"
          target="_blank"
          rel="noopener noreferrer"
          className="btn"
        >
          Yol Tarifi Al
        </Button>

        <Button
          as="a"
          href="https://maps.google.com/?q=Capital%20Antrepo"
          target="_blank"
          rel="noopener noreferrer"
          className="btn"
        >
          Google Maps’te Aç
        </Button>
      </div>
    </CardContent>
  </Card>
</div>

        </div>
      </div>
    </section>
  )
}

export default Contact